/**
 * Help Page
 */

export default function HelpPage() {
  return (
    <div className="px-6 pt-8 pb-12">
      <h1 className="text-xl font-medium text-[#101828] mb-2">Help & Support</h1>
      <p className="text-base text-[#4a5565] mb-8">
        Get help with Audra Flow
      </p>
      
      <div className="bg-white border border-gray-200 rounded-[14px] p-6">
        <p className="text-gray-600">Help documentation coming soon...</p>
      </div>
    </div>
  )
}












